import { Configuration, LogLevel } from '@azure/msal-browser'

const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID || ''
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID || ''

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Warning:
            console.warn(message)
            return
        }
      },
    },
  },
}

export const loginRequest = {
  scopes: ['User.Read', `api://${clientId}/access_as_user`],
}

export const apiScopes = {
  scopes: [`api://${clientId}/access_as_user`],
}
